// extracted by mini-css-extract-plugin
module.exports = {"base":"row1-m__base__36czu","ad-slot":"row1-m__ad-slot__3uegm"};